export default __webpack_public_path__ + "static/media/14.191f4be9.pdf";